import { ReactElement } from 'react';
import ModalAction from '../ModalAction';

interface Props {
    confirmationAction?: () => void;
    setModalOpened: (param: boolean) => void;
    modalOpened: boolean;
    children: ReactElement | string;
}

function ConfirmationModal(props: Props) {
    const { confirmationAction, setModalOpened, modalOpened, children } = props;

    const handleConfirm = () => {
        if (confirmationAction) {
            confirmationAction();
        }
        setModalOpened(false);
    };

    return (
        <ModalAction
            opened={modalOpened}
            setOpened={setModalOpened}
            onClick={() => {
                handleConfirm();
            }}
        >
            <span>{children}</span>
        </ModalAction>
    );
}

export default ConfirmationModal;
